'use client'

import { cn } from '@/lib/utils'

export interface EditorCharacterCountProps {
  characterCount: number
  maxLength?: number
}

/**
 * Character count display for the editor footer
 */
export const EditorCharacterCount = ({ characterCount, maxLength }: EditorCharacterCountProps) => (
  <div className="flex items-center justify-end border-t border-border px-3 py-1.5 text-muted-foreground text-xs">
    <span className={cn(maxLength && characterCount > maxLength && 'text-destructive')}>
      {characterCount}
      {maxLength && ` / ${maxLength}`}
    </span>
  </div>
)

EditorCharacterCount.displayName = 'EditorCharacterCount'
